"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsHublPanelOpenAndUserOverEmbeddableVideoLimit = void 0;

var _reselect = require("reselect");

var _Limits = require("FileManagerCore/selectors/Limits");

var _Constants = require("../Constants");

var _Panel = require("./Panel");

var getIsHublPanelOpenAndUserOverEmbeddableVideoLimit = (0, _reselect.createSelector)([_Panel.getPanelType, _Limits.getHasUserExceededEmbeddableVideoLimit], function (type, exceededLimit) {
  return type === _Constants.DrawerTypes.HUBL_VIDEO && exceededLimit;
});
exports.getIsHublPanelOpenAndUserOverEmbeddableVideoLimit = getIsHublPanelOpenAndUserOverEmbeddableVideoLimit;